import React from 'react';
import { StyleSheet, View, Text } from 'react-native';

import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onSubmit: () => void;
};

const ChangePhoneEmailOTPIsSent = (props: Props) => {
  return (
    <View style={style.container}>
      <View style={style.topContainer}>
        <Text style={style.textTitle}>
          ご登録のメールアドレスに認証コードを送信しました
        </Text>
        <View style={style.spacer} />
        <Text>
          正しいメールアドレスが入力された場合、ご登録中のメールアドレスに認証コードを送信しました。メールをご確認ください。
        </Text>
        <View style={style.spacer} />
      </View>
      <Button
        title="次へ"
        onPress={() => props.onSubmit()}
        style={style.button}
        id="edit-user-phone-next-button"
      />
    </View>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1,
  },
  textTitle: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  spacer: {
    marginBottom: 5,
  },
  button: {
    alignSelf: 'center',
    marginVertical: 8,
  },
  topContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
});

export default ChangePhoneEmailOTPIsSent;
